import { render, staticRenderFns } from "./amount-verification.vue?vue&type=template&id=6d85d203&"
import script from "./amount-verification.vue?vue&type=script&lang=js&"
export * from "./amount-verification.vue?vue&type=script&lang=js&"
import style0 from "./amount-verification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports